import { render, staticRenderFns } from "./PricingPlanCard.vue?vue&type=template&id=50f9f413&scoped=true"
import script from "./PricingPlanCard.vue?vue&type=script&lang=js"
export * from "./PricingPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9f413",
  null
  
)

export default component.exports